import { render, staticRenderFns } from "./AIRocketReg.vue?vue&type=template&id=68ba2395&scoped=true"
import script from "./AIRocketReg.vue?vue&type=script&lang=js"
export * from "./AIRocketReg.vue?vue&type=script&lang=js"
import style0 from "./AIRocketReg.vue?vue&type=style&index=0&id=68ba2395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba2395",
  null
  
)

export default component.exports